/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    JpCoBenefitoneBsCafeDtoInlineResponse400,
    JpCoBenefitoneBsCafeDtoInlineResponse400FromJSON,
    JpCoBenefitoneBsCafeDtoInlineResponse400ToJSON,
    JpCoBenefitoneBsCommonExceptionCommonExceptionHandlerSimpleErrorResponse,
    JpCoBenefitoneBsCommonExceptionCommonExceptionHandlerSimpleErrorResponseFromJSON,
    JpCoBenefitoneBsCommonExceptionCommonExceptionHandlerSimpleErrorResponseToJSON,
    JpCoBenefitoneBsPointDtoInlineResponse400,
    JpCoBenefitoneBsPointDtoInlineResponse400FromJSON,
    JpCoBenefitoneBsPointDtoInlineResponse400ToJSON,
    JpCoBenefitoneBsSubsidyDtoErrorResponseList,
    JpCoBenefitoneBsSubsidyDtoErrorResponseListFromJSON,
    JpCoBenefitoneBsSubsidyDtoErrorResponseListToJSON,
    JpCoBenefitoneBsdpBffDtoBffBoCodePostRequest,
    JpCoBenefitoneBsdpBffDtoBffBoCodePostRequestFromJSON,
    JpCoBenefitoneBsdpBffDtoBffBoCodePostRequestToJSON,
    JpCoBenefitoneBsdpBffDtoBffBoCodePostResponse,
    JpCoBenefitoneBsdpBffDtoBffBoCodePostResponseFromJSON,
    JpCoBenefitoneBsdpBffDtoBffBoCodePostResponseToJSON,
    JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest,
    JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestFromJSON,
    JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestToJSON,
    JpCoBenefitoneBsdpBffDtoBffConfirmPostResponse,
    JpCoBenefitoneBsdpBffDtoBffConfirmPostResponseFromJSON,
    JpCoBenefitoneBsdpBffDtoBffConfirmPostResponseToJSON,
    JpCoBenefitoneBsdpBffPresentationRequestCafePutRequest,
    JpCoBenefitoneBsdpBffPresentationRequestCafePutRequestFromJSON,
    JpCoBenefitoneBsdpBffPresentationRequestCafePutRequestToJSON,
    JpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequest,
    JpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequestFromJSON,
    JpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequestToJSON,
    JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest,
    JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequestFromJSON,
    JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequestToJSON,
    JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest,
    JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequestFromJSON,
    JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequestToJSON,
    JpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequest,
    JpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequestFromJSON,
    JpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequestToJSON,
    JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest,
    JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestFromJSON,
    JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestToJSON,
    JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponse,
    JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponseFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponseToJSON,
    JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponse,
    JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponseFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponseToJSON,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponse,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseToJSON,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseToJSON,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseToJSON,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmSelectPayPostResponse,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmSelectPayPostResponseFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmSelectPayPostResponseToJSON,
    JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse,
    JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponseFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponseToJSON,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseToJSON,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderResponse,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderResponseFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderResponseToJSON,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponse,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseToJSON,
    JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse,
    JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponseFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponseToJSON,
    JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponse,
    JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseToJSON,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseToJSON,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponse,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponseFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponseToJSON,
} from '../models';

export interface GetConfirmRequest {
    boCode?: string;
}

export interface GetOrderFellowTravelersRequest {
    acptNo: string;
    companionEntryId: string;
    tSTBOJSESSIONID?: string;
}

export interface GetSubsidyRequest {
    personAccompanyFlag?: string;
}

export interface GetSubsidyFellowTravelersRequest {
    personAccompanyFlag?: string;
}

export interface PostBoCodeRequest {
    jpCoBenefitoneBsdpBffDtoBffBoCodePostRequest: JpCoBenefitoneBsdpBffDtoBffBoCodePostRequest;
}

export interface PostConfirmRequest {
    jpCoBenefitoneBsdpBffDtoBffConfirmPostRequest: JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest;
    tSTBOJSESSIONID?: string;
}

export interface PostConfirmNoPaymentRequest {
    jpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest: JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest;
}

export interface PostConfirmPayRequest {
    p: string;
    jpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequest: JpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequest;
}

export interface PostConfirmSelectPayRequest {
    payMthdDiv: string;
    jpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequest: JpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequest;
}

export interface PostOrderRequest {
    jpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest: JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest;
    tSTBOJSESSIONID?: string;
}

export interface PutBenepoRequest {
    benepoAmountTotal: string;
}

export interface PutBenepoFellowTravelersRequest {
    benepoAmountTotal: string;
}

export interface PutCafeRequest {
    jpCoBenefitoneBsdpBffPresentationRequestCafePutRequest: JpCoBenefitoneBsdpBffPresentationRequestCafePutRequest;
}

export interface PutCafeFellowTravelersRequest {
    jpCoBenefitoneBsdpBffPresentationRequestCafePutRequest: JpCoBenefitoneBsdpBffPresentationRequestCafePutRequest;
}

export interface PutSubsidyRequest {
    jpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest: JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest;
}

export interface PutSubsidyFellowTravelersRequest {
    jpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest: JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest;
}

/**
 * 
 */
export class DPApi extends runtime.BaseAPI {

    /**
     * ベネポ申請（モーダル）画面表示に必要な情報を取得する
     */
    async getBenepoRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/dp/order/benepo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponseFromJSON(jsonValue));
    }

    /**
     * ベネポ申請（モーダル）画面表示に必要な情報を取得する
     */
    async getBenepo(initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponse> {
        const response = await this.getBenepoRaw(initOverrides);
        return await response.value();
    }

    /**
     * ベネポ申請（モーダル）画面表示に必要な情報を取得する
     */
    async getBenepoFellowTravelersRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/fellowtravelers/order/benepo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponseFromJSON(jsonValue));
    }

    /**
     * ベネポ申請（モーダル）画面表示に必要な情報を取得する
     */
    async getBenepoFellowTravelers(initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseBenepoGetResponse> {
        const response = await this.getBenepoFellowTravelersRaw(initOverrides);
        return await response.value();
    }

    /**
     * カフェポイント申請（モーダル）画面表示に必要な情報を取得する
     */
    async getCafeRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/dp/order/cafe`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseFromJSON(jsonValue));
    }

    /**
     * カフェポイント申請（モーダル）画面表示に必要な情報を取得する
     */
    async getCafe(initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponse> {
        const response = await this.getCafeRaw(initOverrides);
        return await response.value();
    }

    /**
     * カフェポイント申請（モーダル）画面表示に必要な情報を取得する
     */
    async getCafeFellowTravelersRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/fellowtravelers/order/cafe`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseFromJSON(jsonValue));
    }

    /**
     * カフェポイント申請（モーダル）画面表示に必要な情報を取得する
     */
    async getCafeFellowTravelers(initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponse> {
        const response = await this.getCafeFellowTravelersRaw(initOverrides);
        return await response.value();
    }

    /**
     * 申込確認画面表示に必要な情報を取得する
     */
    async getConfirmRaw(requestParameters: GetConfirmRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse>> {
        const queryParameters: any = {};

        if (requestParameters.boCode !== undefined) {
            queryParameters['boCode'] = requestParameters.boCode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/dp/order/confirm`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseFromJSON(jsonValue));
    }

    /**
     * 申込確認画面表示に必要な情報を取得する
     */
    async getConfirm(requestParameters: GetConfirmRequest = {}, initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse> {
        const response = await this.getConfirmRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrderConfirmFellowTravelersRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/fellowtravelers/order/confirm`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseFromJSON(jsonValue));
    }

    /**
     */
    async getOrderConfirmFellowTravelers(initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponse> {
        const response = await this.getOrderConfirmFellowTravelersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrderFellowTravelersRaw(requestParameters: GetOrderFellowTravelersRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderResponse>> {
        if (requestParameters.acptNo === null || requestParameters.acptNo === undefined) {
            throw new runtime.RequiredError('acptNo','Required parameter requestParameters.acptNo was null or undefined when calling getOrderFellowTravelers.');
        }

        if (requestParameters.companionEntryId === null || requestParameters.companionEntryId === undefined) {
            throw new runtime.RequiredError('companionEntryId','Required parameter requestParameters.companionEntryId was null or undefined when calling getOrderFellowTravelers.');
        }

        const queryParameters: any = {};

        if (requestParameters.acptNo !== undefined) {
            queryParameters['acptNo'] = requestParameters.acptNo;
        }

        if (requestParameters.companionEntryId !== undefined) {
            queryParameters['companionEntryId'] = requestParameters.companionEntryId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/fellowtravelers/order`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderResponseFromJSON(jsonValue));
    }

    /**
     */
    async getOrderFellowTravelers(requestParameters: GetOrderFellowTravelersRequest, initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderResponse> {
        const response = await this.getOrderFellowTravelersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 補助金申請（モーダル）画面表示に必要な情報を取得する
     */
    async getSubsidyRaw(requestParameters: GetSubsidyRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse>> {
        const queryParameters: any = {};

        if (requestParameters.personAccompanyFlag !== undefined) {
            queryParameters['personAccompanyFlag'] = requestParameters.personAccompanyFlag;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/dp/order/subsidy`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseFromJSON(jsonValue));
    }

    /**
     * 補助金申請（モーダル）画面表示に必要な情報を取得する
     */
    async getSubsidy(requestParameters: GetSubsidyRequest = {}, initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse> {
        const response = await this.getSubsidyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 補助金申請（モーダル）画面表示に必要な情報を取得する
     */
    async getSubsidyFellowTravelersRaw(requestParameters: GetSubsidyFellowTravelersRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse>> {
        const queryParameters: any = {};

        if (requestParameters.personAccompanyFlag !== undefined) {
            queryParameters['personAccompanyFlag'] = requestParameters.personAccompanyFlag;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/fellowtravelers/order/subsidy`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseFromJSON(jsonValue));
    }

    /**
     * 補助金申請（モーダル）画面表示に必要な情報を取得する
     */
    async getSubsidyFellowTravelers(requestParameters: GetSubsidyFellowTravelersRequest = {}, initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponse> {
        const response = await this.getSubsidyFellowTravelersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 補助金申請後、ANABFFへリクエストする
     */
    async postAnaConfirmNoPaymentRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/dp/order/ana/confirm/no-payment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponseFromJSON(jsonValue));
    }

    /**
     * 補助金申請後、ANABFFへリクエストする
     */
    async postAnaConfirmNoPayment(initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseAnaConfirmNoPaymentPostResponse> {
        const response = await this.postAnaConfirmNoPaymentRaw(initOverrides);
        return await response.value();
    }

    /**
     * boCodeを取得する。
     */
    async postBoCodeRaw(requestParameters: PostBoCodeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffDtoBffBoCodePostResponse>> {
        if (requestParameters.jpCoBenefitoneBsdpBffDtoBffBoCodePostRequest === null || requestParameters.jpCoBenefitoneBsdpBffDtoBffBoCodePostRequest === undefined) {
            throw new runtime.RequiredError('jpCoBenefitoneBsdpBffDtoBffBoCodePostRequest','Required parameter requestParameters.jpCoBenefitoneBsdpBffDtoBffBoCodePostRequest was null or undefined when calling postBoCode.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/dp/bff/boCode`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JpCoBenefitoneBsdpBffDtoBffBoCodePostRequestToJSON(requestParameters.jpCoBenefitoneBsdpBffDtoBffBoCodePostRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffDtoBffBoCodePostResponseFromJSON(jsonValue));
    }

    /**
     * boCodeを取得する。
     */
    async postBoCode(requestParameters: PostBoCodeRequest, initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffDtoBffBoCodePostResponse> {
        const response = await this.postBoCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 補助金・カフェ・ベネポ申請に必要な情報を取得する
     */
    async postConfirmRaw(requestParameters: PostConfirmRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffDtoBffConfirmPostResponse>> {
        if (requestParameters.jpCoBenefitoneBsdpBffDtoBffConfirmPostRequest === null || requestParameters.jpCoBenefitoneBsdpBffDtoBffConfirmPostRequest === undefined) {
            throw new runtime.RequiredError('jpCoBenefitoneBsdpBffDtoBffConfirmPostRequest','Required parameter requestParameters.jpCoBenefitoneBsdpBffDtoBffConfirmPostRequest was null or undefined when calling postConfirm.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/dp/bff/confirm`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestToJSON(requestParameters.jpCoBenefitoneBsdpBffDtoBffConfirmPostRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffDtoBffConfirmPostResponseFromJSON(jsonValue));
    }

    /**
     * 補助金・カフェ・ベネポ申請に必要な情報を取得する
     */
    async postConfirm(requestParameters: PostConfirmRequest, initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffDtoBffConfirmPostResponse> {
        const response = await this.postConfirmRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 支払い無しで、申込処理をする
     */
    async postConfirmNoPaymentRaw(requestParameters: PostConfirmNoPaymentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponse>> {
        if (requestParameters.jpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest === null || requestParameters.jpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest === undefined) {
            throw new runtime.RequiredError('jpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest','Required parameter requestParameters.jpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest was null or undefined when calling postConfirmNoPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/dp/order/confirm/no-payment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequestToJSON(requestParameters.jpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseFromJSON(jsonValue));
    }

    /**
     * 支払い無しで、申込処理をする
     */
    async postConfirmNoPayment(requestParameters: PostConfirmNoPaymentRequest, initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponse> {
        const response = await this.postConfirmNoPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 支払処理をする
     */
    async postConfirmPayRaw(requestParameters: PostConfirmPayRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse>> {
        if (requestParameters.p === null || requestParameters.p === undefined) {
            throw new runtime.RequiredError('p','Required parameter requestParameters.p was null or undefined when calling postConfirmPay.');
        }

        if (requestParameters.jpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequest === null || requestParameters.jpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequest === undefined) {
            throw new runtime.RequiredError('jpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequest','Required parameter requestParameters.jpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequest was null or undefined when calling postConfirmPay.');
        }

        const queryParameters: any = {};

        if (requestParameters.p !== undefined) {
            queryParameters['p'] = requestParameters.p;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/dp/order/confirm/pay`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequestToJSON(requestParameters.jpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseFromJSON(jsonValue));
    }

    /**
     * 支払処理をする
     */
    async postConfirmPay(requestParameters: PostConfirmPayRequest, initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse> {
        const response = await this.postConfirmPayRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 支払い有で、支払方法選択処理をする
     */
    async postConfirmSelectPayRaw(requestParameters: PostConfirmSelectPayRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseConfirmSelectPayPostResponse>> {
        if (requestParameters.payMthdDiv === null || requestParameters.payMthdDiv === undefined) {
            throw new runtime.RequiredError('payMthdDiv','Required parameter requestParameters.payMthdDiv was null or undefined when calling postConfirmSelectPay.');
        }

        if (requestParameters.jpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequest === null || requestParameters.jpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequest === undefined) {
            throw new runtime.RequiredError('jpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequest','Required parameter requestParameters.jpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequest was null or undefined when calling postConfirmSelectPay.');
        }

        const queryParameters: any = {};

        if (requestParameters.payMthdDiv !== undefined) {
            queryParameters['payMthdDiv'] = requestParameters.payMthdDiv;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/dp/order/confirm/select-pay`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequestToJSON(requestParameters.jpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseConfirmSelectPayPostResponseFromJSON(jsonValue));
    }

    /**
     * 支払い有で、支払方法選択処理をする
     */
    async postConfirmSelectPay(requestParameters: PostConfirmSelectPayRequest, initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseConfirmSelectPayPostResponse> {
        const response = await this.postConfirmSelectPayRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 外部サイトへ遷移ボタン押下時に画面から呼ばれる
     */
    async postExternalRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/dp/order/external`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponseFromJSON(jsonValue));
    }

    /**
     * 外部サイトへ遷移ボタン押下時に画面から呼ばれる
     */
    async postExternal(initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse> {
        const response = await this.postExternalRaw(initOverrides);
        return await response.value();
    }

    /**
     * ポイント、カフェ申請後、補助金申請BFFへリクエストする
     */
    async postJalConfirmRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/dp/order/jal/confirm`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponseFromJSON(jsonValue));
    }

    /**
     * ポイント、カフェ申請後、補助金申請BFFへリクエストする
     */
    async postJalConfirm(initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse> {
        const response = await this.postJalConfirmRaw(initOverrides);
        return await response.value();
    }

    /**
     * 申込処理完了後、JAL_BFFへリクエストする
     */
    async postJalConfirm1Raw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/dp/bff/jal/confirm`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 申込処理完了後、JAL_BFFへリクエストする
     */
    async postJalConfirm1(initOverrides?: RequestInit): Promise<void> {
        await this.postJalConfirm1Raw(initOverrides);
    }

    /**
     * ダイナミックパッケージを申し込む
     */
    async postOrderRaw(requestParameters: PostOrderRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.jpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest === null || requestParameters.jpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest === undefined) {
            throw new runtime.RequiredError('jpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest','Required parameter requestParameters.jpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest was null or undefined when calling postOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/dp/order`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequestToJSON(requestParameters.jpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * ダイナミックパッケージを申し込む
     */
    async postOrder(requestParameters: PostOrderRequest, initOverrides?: RequestInit): Promise<string> {
        const response = await this.postOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 補助金申請後、楽天BFFへリクエストする
     */
    async postRakutenConfirmRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/dp/order/rakuten/confirm`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * 補助金申請後、楽天BFFへリクエストする
     */
    async postRakutenConfirm(initOverrides?: RequestInit): Promise<string> {
        const response = await this.postRakutenConfirmRaw(initOverrides);
        return await response.value();
    }

    /**
     * ベネポ申請（モーダル）でベネポをチェックし、ベネポ申請を確定する
     */
    async putBenepoRaw(requestParameters: PutBenepoRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.benepoAmountTotal === null || requestParameters.benepoAmountTotal === undefined) {
            throw new runtime.RequiredError('benepoAmountTotal','Required parameter requestParameters.benepoAmountTotal was null or undefined when calling putBenepo.');
        }

        const queryParameters: any = {};

        if (requestParameters.benepoAmountTotal !== undefined) {
            queryParameters['benepoAmountTotal'] = requestParameters.benepoAmountTotal;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/dp/order/benepo`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ベネポ申請（モーダル）でベネポをチェックし、ベネポ申請を確定する
     */
    async putBenepo(requestParameters: PutBenepoRequest, initOverrides?: RequestInit): Promise<void> {
        await this.putBenepoRaw(requestParameters, initOverrides);
    }

    /**
     * ベネポ申請（モーダル）でベネポをチェックし、ベネポ申請を確定する
     */
    async putBenepoFellowTravelersRaw(requestParameters: PutBenepoFellowTravelersRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.benepoAmountTotal === null || requestParameters.benepoAmountTotal === undefined) {
            throw new runtime.RequiredError('benepoAmountTotal','Required parameter requestParameters.benepoAmountTotal was null or undefined when calling putBenepoFellowTravelers.');
        }

        const queryParameters: any = {};

        if (requestParameters.benepoAmountTotal !== undefined) {
            queryParameters['benepoAmountTotal'] = requestParameters.benepoAmountTotal;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/fellowtravelers/order/benepo`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ベネポ申請（モーダル）でベネポをチェックし、ベネポ申請を確定する
     */
    async putBenepoFellowTravelers(requestParameters: PutBenepoFellowTravelersRequest, initOverrides?: RequestInit): Promise<void> {
        await this.putBenepoFellowTravelersRaw(requestParameters, initOverrides);
    }

    /**
     * カフェポイント申請（モーダル）でカフェポイントをチェックし、カフェポイント申請を確定する
     */
    async putCafeRaw(requestParameters: PutCafeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.jpCoBenefitoneBsdpBffPresentationRequestCafePutRequest === null || requestParameters.jpCoBenefitoneBsdpBffPresentationRequestCafePutRequest === undefined) {
            throw new runtime.RequiredError('jpCoBenefitoneBsdpBffPresentationRequestCafePutRequest','Required parameter requestParameters.jpCoBenefitoneBsdpBffPresentationRequestCafePutRequest was null or undefined when calling putCafe.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/dp/order/cafe`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: JpCoBenefitoneBsdpBffPresentationRequestCafePutRequestToJSON(requestParameters.jpCoBenefitoneBsdpBffPresentationRequestCafePutRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * カフェポイント申請（モーダル）でカフェポイントをチェックし、カフェポイント申請を確定する
     */
    async putCafe(requestParameters: PutCafeRequest, initOverrides?: RequestInit): Promise<void> {
        await this.putCafeRaw(requestParameters, initOverrides);
    }

    /**
     * カフェポイント申請（モーダル）でカフェポイントをチェックし、カフェポイント申請を確定する
     */
    async putCafeFellowTravelersRaw(requestParameters: PutCafeFellowTravelersRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.jpCoBenefitoneBsdpBffPresentationRequestCafePutRequest === null || requestParameters.jpCoBenefitoneBsdpBffPresentationRequestCafePutRequest === undefined) {
            throw new runtime.RequiredError('jpCoBenefitoneBsdpBffPresentationRequestCafePutRequest','Required parameter requestParameters.jpCoBenefitoneBsdpBffPresentationRequestCafePutRequest was null or undefined when calling putCafeFellowTravelers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/fellowtravelers/order/cafe`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: JpCoBenefitoneBsdpBffPresentationRequestCafePutRequestToJSON(requestParameters.jpCoBenefitoneBsdpBffPresentationRequestCafePutRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * カフェポイント申請（モーダル）でカフェポイントをチェックし、カフェポイント申請を確定する
     */
    async putCafeFellowTravelers(requestParameters: PutCafeFellowTravelersRequest, initOverrides?: RequestInit): Promise<void> {
        await this.putCafeFellowTravelersRaw(requestParameters, initOverrides);
    }

    /**
     */
    async putOrderApplyFellowTravelersRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/fellowtravelers/order/apply`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseFromJSON(jsonValue));
    }

    /**
     */
    async putOrderApplyFellowTravelers(initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponse> {
        const response = await this.putOrderApplyFellowTravelersRaw(initOverrides);
        return await response.value();
    }

    /**
     * 補助金申請（モーダル）で補助金をチェックし、補助金申請を確定する
     */
    async putSubsidyRaw(requestParameters: PutSubsidyRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponse>> {
        if (requestParameters.jpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest === null || requestParameters.jpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest === undefined) {
            throw new runtime.RequiredError('jpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest','Required parameter requestParameters.jpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest was null or undefined when calling putSubsidy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/dp/order/subsidy`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestToJSON(requestParameters.jpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponseFromJSON(jsonValue));
    }

    /**
     * 補助金申請（モーダル）で補助金をチェックし、補助金申請を確定する
     */
    async putSubsidy(requestParameters: PutSubsidyRequest, initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponse> {
        const response = await this.putSubsidyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 補助金申請（モーダル）で補助金をチェックし、補助金申請を確定する
     */
    async putSubsidyFellowTravelersRaw(requestParameters: PutSubsidyFellowTravelersRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponse>> {
        if (requestParameters.jpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest === null || requestParameters.jpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest === undefined) {
            throw new runtime.RequiredError('jpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest','Required parameter requestParameters.jpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest was null or undefined when calling putSubsidyFellowTravelers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/fellowtravelers/order/subsidy`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestToJSON(requestParameters.jpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponseFromJSON(jsonValue));
    }

    /**
     * 補助金申請（モーダル）で補助金をチェックし、補助金申請を確定する
     */
    async putSubsidyFellowTravelers(requestParameters: PutSubsidyFellowTravelersRequest, initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseSubsidyPutResponse> {
        const response = await this.putSubsidyFellowTravelersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
